import React from 'react';
import Typography from '@mui/material/Typography';
import { InterventionCenterFaxPerPoliceStation } from '../../../common/types/statistics/fhbfStatistics';
import { Option } from '../../../common/types/form';
import formatter from '../../../common/helpers/formatter';

type Props = {
  policeStationOptions: Option[];
  faxesPerPoliceStation: InterventionCenterFaxPerPoliceStation;
};

function FaxesStatistics(props: Props) {
  const { policeStationOptions, faxesPerPoliceStation } = props;
  const { policeStation, numberOfFaxes, numberOfHgwClerk, numberOfPatrolman, numberOfBpfk } = faxesPerPoliceStation;

  const headline = formatter.getOptionLabel(policeStationOptions, policeStation);

  const getFaxLabel = (numberOfFaxes: number): string => {
    if (numberOfFaxes === 1) {
      return `${numberOfFaxes} Fax`;
    }
    return `${numberOfFaxes} Faxe`;
  };

  return (
    <>
      <Typography fontWeight='bold' mt={1}>
        {}
      </Typography>
      <Typography>
        Faxe {headline}: {getFaxLabel(numberOfFaxes)}
      </Typography>
      <Typography>Davon versendet von Streifenpolizist*innen: {getFaxLabel(numberOfPatrolman)}</Typography>
      <Typography>Davon versendet von HGW Sachbearbeiterin: {getFaxLabel(numberOfHgwClerk)}</Typography>
      <Typography mb={1}>Davon versendet von BPFK: {getFaxLabel(numberOfBpfk)}</Typography>
    </>
  );
}

export default FaxesStatistics;
